import { createRoot } from 'react-dom/client';
import './index.css';

// Fetch per-environment feature flags from the box we're served by BEFORE the
// app (and feature-flags.js) load, so the same bundle runs everywhere and each
// environment supplies its own flags. Falls back to the compiled defaults if
// the call fails — same behaviour as before this existed.
async function boot() {
  try {
    const res = await fetch('/api/config', { credentials: 'same-origin' });
    if (res.ok) {
      const { flags, auth } = await res.json();
      if (flags && typeof flags === 'object') window.__CTS_FLAGS = flags;
      // Which sign-in methods this box offers (LoginPage reads it; see server.js authMethods).
      if (auth && typeof auth === 'object') window.__CTS_AUTH = auth;
    }
  } catch { /* keep compiled defaults */ }
  // Dynamic import AFTER window.__CTS_FLAGS is set — feature-flags.js reads it at
  // module-eval time, so the order matters.
  const { default: App } = await import('./App');
  createRoot(document.getElementById('root')).render(<App />);
}

boot();
